import { IFilterComponent, SearchFilter } from '../../../../infrastructure/iFilter-component';
import { OnInit, Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FilterService } from '../../../../services/filter.service';
import { AuthService } from '../../../../services/auth.service';
import { FilterRecordService } from '../../../../services/filter-record.service';
import { LogisticsService } from '../../../../services/logistics.service';

@Component({
    selector: 'send-order-logistics-filter',
    templateUrl: './send-order-logistics-filter.component.html',
    styleUrls: ['./send-order-logistics-filter.component.css']
})
export class SendOrderLogisticsFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: [''],
      ShowSend: [false],
      ShowDeleted: [false],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('SendOrderLogisticsFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('SendOrderLogisticsFilterComponent', this.form);
  }

  async search(): Promise<any> {
    const showDeleted = this.form.controls.ShowDeleted.value ? <boolean>this.form.controls.ShowDeleted.value : false;
    const showSend = this.form.controls.ShowSend.value ? <boolean>this.form.controls.ShowSend.value : false;
    return await this.logisticsService.getOrderBatches(
      showDeleted
      , showSend
      , this.form.controls.Name.value
      , this.authService.getSectorId());
  }

  async ngOnInit() {

  }
}
